import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a9b1eaal9m: FaireBrandEntity = {
  token: "b_a9b1eaal9m",
  type: "brand",
  name: "Daphyl's LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/fc662190646e408c1f3236ee43cf9110adc75f6d4384ba38665e62ada0da299b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/12e28937072858b489f22c6e9bfa45e7a98a10162dba0eee7708e6bb98a3aa6c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/fc662190646e408c1f3236ee43cf9110adc75f6d4384ba38665e62ada0da299b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/12e28937072858b489f22c6e9bfa45e7a98a10162dba0eee7708e6bb98a3aa6c.png",
  location: "teaneck, NJ, USA",
  minimumOrderDollars: 207,
  rating: 4.9,
  reviewCount: 10,
  isTopShop: true,
  isInsider: true,
  description:
    'Daphyl\'s was born out of the strong desire to bring a little fun and Rock N Roll edge to super high quality baby gear. As the founder of the company I had it with giraffes, dinosaurs, butterflies and the litany of watered down over sanitized licensed "baby" characters for kids. We set out to create lifestyle essentials, that are still "baby / toddler" , but with just bit more personality than the average fare. We over achieved our mission with our Pantera Stroller and Pink Floyd, Dark Side of the Moon sippy cup but we\'ll take it. As we near 10 years of business everyone involved in Daphyl\'s from the manufacturing team in Asia to the warehouse management in NJ all the way to the iconic bands (they all rock our gear for their kids and grand kids) we work with, bringing Rock n Roll to the youngest generation is an awesome experience. ',
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:08.551Z",
    importedBy: "entity-db-cli",
  },
};
